import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { Shield, Mail, Lock, ArrowLeft } from 'lucide-react';

const AdminLoginPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Simple admin authentication for demo
      if (email === 'admin@mi-panui.com' && password === 'admin123456') {
        localStorage.setItem('adminToken', 'demo-admin-token');
        toast.success('התחברות מוצלחת!');
        navigate('/admin/dashboard');
      } else {
        toast.error('פרטי התחברות שגויים');
      }
    } catch (error) {
      toast.error('שגיאה בהתחברות');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-brown-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Skip link targets */}
        <div id="main-content" className="sr-only" tabIndex="-1">תוכן ראשי</div>
        
        {/* Header */}
        <div id="navigation" className="text-center" tabIndex="-1">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-orange-600 hover:text-orange-700 mb-6 mx-auto text-lg font-semibold transition-colors duration-300"
          >
            <ArrowLeft className="h-5 w-5 ml-3" />
            חזור לדף הבית
          </button>
          
          <div className="flex justify-center mb-6">
            <div className="bg-orange-100 p-4 rounded-full">
              <Shield className="h-16 w-16 text-orange-600" />
            </div>
          </div>
          <h2 className="text-4xl font-bold text-brown-900 mb-4">
            התחברות מנהל
          </h2>
          <p className="text-lg text-brown-700">
            התחבר למערכת הניהול
          </p>
        </div>

        {/* Login Form */}
        <div className="card hover-lift">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="space-y-6">
              <div>
                <label htmlFor="admin-email" className="form-label flex items-center">
                  <div className="bg-orange-100 p-2 rounded-full ml-3">
                    <Mail className="h-4 w-4 text-orange-600" />
                  </div>
                  כתובת אימייל
                </label>
                <input
                  id="admin-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  maxLength={100}
                  className="input-field"
                  placeholder="הזן את כתובת האימייל שלך"
                  required
                />
              </div>

              <div>
                <label htmlFor="admin-password" className="form-label flex items-center">
                  <div className="bg-orange-100 p-2 rounded-full ml-3">
                    <Lock className="h-4 w-4 text-orange-600" />
                  </div>
                  סיסמה
                </label>
                <input
                  id="admin-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  maxLength={128}
                  className="input-field"
                  placeholder="הזן את הסיסמה שלך"
                  required
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn-primary w-full py-4 text-lg disabled:opacity-50 disabled:cursor-not-allowed hover-lift"
              >
                {isSubmitting ? (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white ml-2"></div>
                    מתחבר...
                  </div>
                ) : (
                  'התחבר'
                )}
              </button>
            </div>

            <div className="text-center">
              <p className="text-brown-600">
                פרטי התחברות לדמו: admin@mi-panui.com / admin123456
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
